import { render, staticRenderFns } from "./ReviewCardMeta.vue?vue&type=template&id=7f7552e9&scoped=true&"
import script from "./ReviewCardMeta.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardMeta.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardMeta.vue?vue&type=style&index=0&id=7f7552e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7552e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7552e9')) {
      api.createRecord('7f7552e9', component.options)
    } else {
      api.reload('7f7552e9', component.options)
    }
    module.hot.accept("./ReviewCardMeta.vue?vue&type=template&id=7f7552e9&scoped=true&", function () {
      api.rerender('7f7552e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardMeta.vue"
export default component.exports